var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "hero is-fullheight" }, [
        _c("div", { staticClass: "hero-body" }, [
          _c("div", { staticClass: "container has-text-centered" }, [
            _c("h1", { staticClass: "title is-3 is-marginless" }, [
              _vm._v("Cerrando sesion"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }